import { ObservableArray, View, ViewModel } from "binder";
import { ContentElement } from "../components/content/content-viewModel";
import { DummyPlaceHolderElement } from "../components/dummyPlaceHolder/dummyPlaceHolder-viewModel";
import { InputElement } from "../components/input/input-viewModel";
import { ElementDecorator, FormBuilderElement } from "./element";
import { ComponentDropDecoratorViewModel } from "./elementDecorators/ComponentDropDecorator/componentDropDecorator-viewModel";
import { ComponentSelectDecoratorViewModel } from "./elementDecorators/componentSelectDecorator/componentSelectDecorator-viewModel";
import { DragableElementDecoratorViewModel } from "./elementDecorators/dragableElementDecorator/dragableElementDecorator-viewModel";
import { ErroredElementViewModel } from "./elementDecorators/erroredElement/erroredElement-viewModel";
import { ClassListPropertyType, FontStylePropertyType, FontWeightPropertyType, PropertyType, StringPropertyType } from "./propertyTypes/propetyTypes";

export abstract class FormBuilderComponent extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.members = ObservableArray.create<Member>();
        this.addProperty("Class","class",new ClassListPropertyType(this),this.getClassDefaultValue(),false);
        this.addProperty("Style","style",new StringPropertyType(this),"",false);
        this.addProperty("FontSize","font-size",new StringPropertyType(this),"unset",false)
        this.addProperty("FontFamily","font-family",new StringPropertyType(this),"unset",false)
        this.addProperty("FontWeight","font-weight",new FontWeightPropertyType(this),"unset",false)
        this.addProperty("FontStyle","font-style",new FontStylePropertyType(this),"unset",false)
    }
    
    public set members(v: ObservableArray<Member>) { this._members = v; } public get members(): ObservableArray<Member> { return this._members;} private _members: ObservableArray<Member>;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set canAcceptContent(v: boolean) { this._canAcceptContent = v; } public get canAcceptContent(): boolean { return this._canAcceptContent;} private _canAcceptContent: boolean;
    
    protected getClassDefaultValue(){
        return "";
    }
    decorate(parent:ViewModel,element:FormBuilderElement):FormBuilderElement{
        let decorators : ElementDecorator[] = [];
        let selectorDecorator  = new ComponentSelectDecoratorViewModel(parent);
        decorators.push(selectorDecorator);
        let errorDecorator  = new ErroredElementViewModel(decorators[decorators.length-1]);
        decorators.push(errorDecorator);

        if(this.canAcceptContent){
            let dropContainerDecorator = new ComponentDropDecoratorViewModel(decorators[decorators.length-1]);
            decorators.push(dropContainerDecorator);
        }
        let dragElementDecorator = new DragableElementDecoratorViewModel(decorators[decorators.length-1]);
        decorators.push(dragElementDecorator);

        element.parentViewModel = decorators[decorators.length-1];
        decorators.push(<any>element);
        for(let i=decorators.length-2;i>=0;i--){
            let current = decorators[i];
            let component = decorators[i+1];
            (<any>current).decoratorComponent = component;
        }
        element.self = element;
        element.decoratorHead = <any>decorators[0];
        return element.decoratorHead;
    }
    Create(parent:ViewModel):FormBuilderElement{
        
        let element = this.CreateInternal(parent);
        element = this.decorate(parent,element);
        element.component = this;
        this.getProperties().filter(x=>x instanceof AttachedProperty==false).forEach(x=>{
            element.UnsetPropertyValue(x);
        })
        return element.decoratorHead;
    }
    abstract CreateInternal(parent:ViewModel):FormBuilderElement;

    addProperty(name:string,attributeName:string,propertyType:PropertyType,defaultValue:any,canBeContent:boolean):Property{
        let property = new Property(this);
        property.name = name;
        property.readableName = name;
        property.attributeName = attributeName;
        property.defaultValue = defaultValue;
        property.canBeContent = canBeContent;
        property.propertyType = propertyType;
        this.members.push(property);
        return property;
    }

    addAttachedProperty(name:string,attributeName:string,propertyType:PropertyType,defaultValue:any){
        let property = new AttachedProperty(this);
        property.name = name;
        property.readableName = name;
        property.attributeName = attributeName;
        property.defaultValue = defaultValue;
        property.canBeContent = false;
        property.propertyType = propertyType;
        this.members.push(property);
    }

    getProperties():Property[]{
        return this.members.filter(x=>x instanceof Property==true).map(x=><Property>x);
    }
}


export abstract class Member extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.tooltipText = '';
    }
    public set component(v: FormBuilderComponent) { this._component = v; } public get component(): FormBuilderComponent { return this._component;} private _component: FormBuilderComponent;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set readableName(v: string) { this._readableName = v; } public get readableName(): string { return this._readableName;} private _readableName: string;
    public set tooltipText(v: string) { this._tooltipText = v; } public get tooltipText(): string { return this._tooltipText;} private _tooltipText: string;
    
}

export class Property extends Member{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    public set canBeContent(v: boolean) { this._canBeContent = v; } public get canBeContent(): boolean { return this._canBeContent;} private _canBeContent: boolean;
    public set defaultValue(v: object) { this._defaultValue = v; } public get defaultValue(): object { return this._defaultValue;} private _defaultValue: object;
    public set attributeName(v: string) { this._attributeName = v; } public get attributeName(): string { return this._attributeName;} private _attributeName: string;
    public set propertyType(v: PropertyType) { this._propertyType = v; } public get propertyType(): PropertyType { return this._propertyType;} private _propertyType: PropertyType;
    
}

export class AttachedProperty extends Property{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.DummyForAttachedProperty = ''    
    }
    public set DummyForAttachedProperty(v: any) { this._DummyForAttachedProperty = v; } public get DummyForAttachedProperty(): any { return this._DummyForAttachedProperty;} private _DummyForAttachedProperty: any;
        
    
}

export class EventProperty extends Property{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
}



export class FunctionMember extends Member{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
}
